import { render, staticRenderFns } from "./addEvent.vue?vue&type=template&id=5b74bc42"
import script from "./addEvent.vue?vue&type=script&lang=js"
export * from "./addEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports